// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"25":"ed343c02582f9780","814":"1723929b50219aa0"}[chunkId] + ".js";
};